import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect, Route, Switch } from 'react-router-dom';

import { AppRoutes } from 'routes';

/**
 * LocalizedSwitch appends a locale to the path prop of each Route component passed as a child.
 * i.e path: /login -> en/login
 */

export const LocalizedSwitch = ({ children }) => {
    const { formatMessage, locale } = useIntl();
    const localizeRoute = (path) => {
        switch (typeof path) {
            case 'undefined':
                return undefined;
            case 'object':
                return path.map((p) => `/${locale}` + p);
            default:
                const isFallbackRoute = path === '*';
                return isFallbackRoute ? path : `/${locale}` + formatMessage({ id: path });
        }
    };

    return (
        <Switch>
            {React.Children.map(children, (child) => {
                const Component = React.isValidElement(child)
                    ? React.cloneElement(child, {
                          ...child.props,
                          path: localizeRoute(child.props.path),
                      })
                    : child;
                return Component;
            })}
            <Route path="*">
                <Redirect to={`/${locale}` + formatMessage({ id: AppRoutes.pageNotFound })} />
            </Route>
        </Switch>
    );
};
